import TEXT from '../text';

/**
 * @type {import('mui-datatables').MUIDataTableColumnDef[]}
 */
const DEFAULT_COLUMNS = [
  {
    name: 'id',
    options: {
      display: 'excluded',
      sort: false,
      filter: false
    }
  },
  {
    name: 'salutation',
    label: TEXT.CounterPartTable.tableCellHeader.salutation
  },
  {
    name: 'title',
    label: TEXT.CounterPartTable.tableCellHeader.title
  },
  {
    name: 'firstName',
    label: TEXT.CounterPartTable.tableCellHeader.firstName
  },
  {
    name: 'lastName',
    label: TEXT.CounterPartTable.tableCellHeader.lastName
  },
  {
    name: 'faxNumber',
    label: TEXT.CounterPartTable.tableCellHeader.faxNumber
  },
  {
    name: 'phoneNumber',
    label: TEXT.CounterPartTable.tableCellHeader.phoneNumber
  },
  {
    name: 'phoneNumberMobile',
    label: TEXT.CounterPartTable.tableCellHeader.phoneNumberMobile
  },
  {
    name: 'mailAddress',
    label: TEXT.CounterPartTable.tableCellHeader.mailAddress
  },
  {
    name: 'division',
    label: TEXT.CounterPartTable.tableCellHeader.division
  },
  {
    name: 'hierarchyLevel',
    label: TEXT.CounterPartTable.tableCellHeader.hierarchyLevel
  },
  {
    name: 'position',
    label: TEXT.CounterPartTable.tableCellHeader.position
  }
];

const counterPartColumns = {
  DEFAULT_COLUMNS
};

export default counterPartColumns;
